



















































































































































































































































































































































































































































































// @ts-nocheck
import Vue from "vue";
import moment from "moment";

import VCalendar from "v-calendar";
Vue.use(VCalendar, {
  firstDayOfWeek: 1
});
import "v-calendar/lib/v-calendar.min.css";

import StreamPage from '../../pages/Stream.vue'
import VideoList from "../video/VideoList.vue";
import VideoPlayer from "../video/VimeoVideo.vue";
import ViewerFrame from "./ViewerFrame.vue";

export default Vue.extend({
  components: { StreamPage, VideoList, VideoPlayer, ViewerFrame },
  props: {
    dates: {
      type: Array as () => Array<string>,
      default: () => {
        return [] as string[];
      }
    },
    isFullscreen: {
      type: Boolean,
      default: false
    },
    initDate: {
      type: String
    },
    images: {
      type: Object,
      default: () => {
        return {} as { [date: string]: any[] };
      }
    },
    logo: {
      type: String
    },
    title: {
      type: String,
      default: "iRis - Time-Lapse Systems Viewer"
    },
    view: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  data() {
    return {
      blend: 0.4,
      catalogue: {
        date: {
          string: this.initDate,
          value: new Date(this.initDate)
        },
        visible: true,
        images: [] as any[]
      },
      controls: {
        visible: true
      },
      frames: [] as ViewerFrame[],
      height: 601,
      maxScale: 10,
      menu: {
        visible: true
      },
      overlay: false,
      selectedFrame: 0,
      share: {
        image: {
          processed: false,
          width: "original",
          widths: ["original", "2560", "1920", "1280", "640"]
        },
        visible: false
      },
      showGrid: false,
      showMenuLeft: false,
      showMenuRight: false,
      showVideo: false,
      showVideoList: false,
      showStream: false,
      video: {},
      wall: {
        fullscreen: false
      },
      zoom: {
        scale: 1,
        x: 0,
        y: 0
      }
    };
  },

  computed: {
    catalogueDateInput: {
      get(): string {
        return moment(this.catalogue.date.value).format("YYYY-MM-DD");
      },
      set(date) {
        this.dateChange(date);
      }
    },
    frameStyles(): any {
      const styles = [] as any[];
      const position = this.overlay ? "absolute" : "relative";
      const size = {
        height: this.overlay ? "100%" : "auto",
        width: this.overlay ? "100%" : 100 / this.frames.length + '%'
      };
      this.frames.forEach((frame, index) => {
        const border =
          index == this.selectedFrame &&
          this.frames.length > 1 &&
          this.overlay == false
            ? {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "yellow"
              }
            : {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black"
              };
        const opacity = this.overlay
          ? 1.15 / (4 * Math.pow(this.blend - index, 4) + 1) - 0.15
          : 1;
        styles.push({
          ...border,
          opacity,
          position,
          ...size
        });
      });
      const ops = styles.map(style => style.opacity);
      return styles;
    },
    screen(): any {
      const a = document.body.clientWidth;
      const b = document.body.clientHeight;
      return { a, b };
    },
    maxFrames(): number {
      if (this.screen.a * this.screen.b < 500000) {
        return 2;
      } else if (this.screen.a * this.screen.b < 1000000) {
        return 4;
      } else {
        return 6;
      }
    },

    zoomControls() {
      return {
        fit: {
          action: 'reset',
          icon: 'expand',
          title: 'Reset Zoom'
        },
        zoomOut: {
          action: "out",
          icon: "minus",
          title: "Zoom Out"
        },
        zoomIn: {
          action: "in",
          icon: "plus",
          title: "Zoom In"
        },
        fullscreen: {
          action: 'fullscreen',
          icon: this.wall.fullscreen ? 'collapse-arrows-alt' : 'expand-arrows-alt',
          title: this.wall.fullscreen ? "Exit Fullscreen" : "Fullscreen"
        }
      }
    },
  },

  methods: {
    addFrame(overlay) {
      this.blend = 0.25;
      if (!this.overlay || this.frames.length < 2) {
        let frame = {} as ViewerFrame;

        if (this.frames.length) {
          const images = this.images[this.catalogueDateInput];
          frame = { ...this.frames[this.selectedFrame] };
          const imageIndex = images.findIndex(
            image => image._id == frame.image._id
          );
          frame.image =
            imageIndex > -1
              ? imageIndex < images.length - 1
                ? images[imageIndex + 1]
                : images[imageIndex]
              : images[images.length - 1];
        } else {
          const images = this.images[this.initDate];
          const image = images[images.length - 1];
          if (image) {
            frame = {
              date: this.initDate,
              image,
              loading: true,
              zoom: this.zoom
            };
          }
        }

        if (frame.image) {
          this.frames.push(frame);
          const index = this.frames.length - 1;
          this.selectedFrame = index;
          this.imageLoading(index);
        } else {
          alert(
            "Could not add new frame. Try selecting an existing frame first."
          );
        }
      }

      if (this.frames.length === 1) {
        const waitForImages = setInterval(() => {
          const catalogue = document.querySelector(".viewer-catalogue-images");
          if (catalogue) {
            this.goToImage("ffw");
            clearInterval(waitForImages);
          }
        }, 500);
      }

      this.overlay = overlay;
      const refs:any = this.$refs
      setTimeout(() => refs.frame.forEach(frame => frame.init()), 100);
    },

    copyText(id) {
      const input: any = document.getElementById(id);
      input.select();
      document.execCommand("copy");
      alert("Image url copied to clipboard.");
    },

    overlayFrames() {
      if (this.frames.length === 1) {
        this.addFrame(true)
        this.selectedFrame = 0;
        this.goToImage("fbw");
      } else {
        this.overlay = !this.overlay
        const refs:any = this.$refs
        refs.frame.forEach(frame => frame.init())
      }
    },
    imageLoading(index) {
      const imageLoading = setInterval(() => {
        const imageEl: any = document.getElementById("image" + index);
        if (imageEl && imageEl.complete) {
          this.$set(this.frames[index], "loading", false);
          clearInterval(imageLoading);
        }
      }, 100);
    },
    dateChange(date) {
      if (!this.images[date]) {
        this.getImages(date);
      }
      const waitForImages = setInterval(() => {
        if (this.images[date]) {
          this.$set(this.catalogue.date, "string", date);
          this.$set(this.catalogue.date, "value", new Date(date));
          // if (this.frames[this.selectedFrame]) {
          //   this.$set(this.frames, this.selectedFrame, Object.assign(this.frames[this.selectedFrame], {date}))
          //   this.selectImage(this.images[date][0])
          // }
          clearInterval(waitForImages);
        }
      }, 50);
    },
    getImages(date) {
      this.$emit("getImages", date);
    },
    getViewerHeight() {
      const getViewer = setInterval(() => {
        const viewer: any = document.querySelector(".viewer");
        if (viewer) {
          this.height = viewer.offsetHeight;
          clearInterval(getViewer);
        }
      });
    },

    async goToImage(dest) {
      if (typeof dest === "number") {
        const images = this.images[this.catalogueDateInput];
        const frame = this.frames[this.selectedFrame];
        this.selectImage(
          images[images.findIndex(image => image._id == frame.image._id) + dest]
        );
      }

      if (dest === "fbw") {
        const date = this.dates[0];
        this.catalogueDateInput = date;
        const waitForImages = setInterval(() => {
          if (this.images[date]) {
            this.selectImage(this.images[date][0]);
            clearInterval(waitForImages);
          }
        }, 50);
      }

      if (dest === "ffw") {
        const date = this.dates[this.dates.length - 1];
        this.catalogueDateInput = date;
        setTimeout(
          () =>
            this.selectImage(this.images[date][this.images[date].length - 1]),
          500
        );
      }
    },
    removeFrame(index) {
      this.blend = 0.25;
      this.frames.splice(index, 1);
      if (this.selectedFrame >= index) {
        this.selectedFrame -= 1;
      }
      const refs:any = this.$refs
      setTimeout(() => refs.frame.forEach(frame => frame.init()), 50);
    },

    async removeImage() {
      await this.goToImage(1);
      this.$emit("removeImage", this.frames[this.selectedFrame].image);
    },
    scrollCatalogue(direction) {
      const catalogue: any = document.querySelector(".viewer-catalogue-images");
      if (direction == "up") {
        catalogue.scrollTop -= catalogue.offsetHeight * 0.9;
      }
      if (direction == "down") {
        catalogue.scrollTop += catalogue.offsetHeight * 0.9;
      }
    },
    selectFrame(frame, index) {
      this.selectedFrame = index;
      setTimeout(() => (this.catalogueDateInput = frame.date));
      // this.$set(this.catalogue.date, "value", new Date(this.frames[this.selectedFrame].date))
    },
    selectImage(image) {
      const frame = this.frames[this.selectedFrame];
      frame.loading = true;
      this.imageLoading(this.selectedFrame);
      frame.image = image;
      frame.date = moment(image.meta.date).format("YYYY-MM-DD");
      this.imageLoading[this.selectedFrame];
      this.frames.splice(this.selectedFrame, 1, frame);

      const catalogue: any = document.querySelector(".viewer-catalogue-images");
      const thumbnail: any = document.getElementById(
        "viewer-catalogue-item-" + image._id
      );

      const catalogueLoad = setInterval(() => {
        if (catalogue && thumbnail) {
          catalogue.scrollTop =
            thumbnail.offsetTop - thumbnail.offsetHeight / 2;
          clearInterval(catalogueLoad);
        }
      }, 50);
    },

    selectVideo(video) {
      (this.video = video),
        (this.showVideo = true),
        (this.showVideoList = false);
    },

    showEmbed() {
      alert("Contact info@time-lapse-systems.com to request embed code.");
    },

    showSharing() {
      const twitter = document.createElement("script");
      twitter.src = "https://platform.twitter.com/widgets.js";
      document.body.appendChild(twitter);

      this.$set(this.share, "visible", true);
    },

    toggleFullscreen() {
      this.wall.fullscreen = !this.wall.fullscreen;
      this.catalogue.visible = !this.wall.fullscreen;
      const refs:any = this.$refs
      refs.frame.forEach(frame => frame.init())
    },

    toggleMenu(side) {
      if (side == "left") {
        this.showMenuLeft = !this.showMenuLeft
        this.showMenuRight = false
      } else if (side == "right") {
        this.showMenuRight = !this.showMenuRight
        this.showMenuLeft = false
      }
    },

    zoomAction(action) {
      const refs:any = this.$refs
      switch (action) {
        case "fullscreen":
          this.toggleFullscreen()
          break;
        case "in":
          this.zoomIn();
          break;
        case "out":
          this.zoomOut();
          break;
        case "reset":
          refs.frame.forEach(frame => frame.init());
          break;
      }
    },
    zoomChange(zoom) {
      const {scale,x,y} = zoom
      this.zoom = {scale,x,y}
      let refs = [] as any
      refs = refs.concat(this.$refs.frame)
      refs.forEach(frame => {
        frame.setTransform({scale,x,y}, true)
      })
    },
    zoomIn() {
      const frame: any = this.$refs.frame[0] //document.querySelector("pinch-zoom");
      frame.scaleTo(this.zoom.scale * 1.38, {
        originX: "50%",
        originY: "50%",
        relativeTo: "container",
        allowChangeEvent: true
      });
    },
    zoomOut() {
      const frame: any = this.$refs.frame[0] //document.querySelector("pinch-zoom");
      frame.scaleTo((this.zoom.scale * 1) / 1.38, {
        originX: "50%",
        originY: "50%",
        relativeTo: "container",
        allowChangeEvent: true
      });
    }
  },

  watch: {
    catalogueDateInput(date) {
      this.dateChange(date);
    }
  },

  created() {
    window.console.log("iRis Viewer Created");
    this.wall.fullscreen = this.isFullscreen;
  },

  mounted() {
    const datesCount = this.dates.length;
    const imageDatesCount = Object.keys(this.images).length;
    this.catalogueDateInput = this.initDate;
    this.addFrame(false);

    this.getViewerHeight();
    window.addEventListener("resize", () => {
      this.getViewerHeight();
    });
  },

  filters: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm")
    }
  }
});
